/**
 * Marcas de tiempo de Suwayomi.
 *
 * Cada extension decide en que unidad manda la fecha de subida y **no todas
 * usan la misma**: las de este servidor van en milisegundos salvo
 * LeerCapitulo, que las manda en segundos. Medido sobre la biblioteca:
 *
 *     Bad Born Blood (Asura)   1787276000000  -> 20/08/2026
 *     One Piece (LeerCapitulo)    1787023951  -> 17/08/2026
 *
 * Tratar los segundos como milisegundos deja el capitulo en enero de 1970,
 * que es justo lo que se veia en la ficha de One Piece. Entre las dos escalas
 * hay tres ordenes de magnitud, asi que distinguirlas es de fiar: 1e11 en
 * segundos cae en el ano 5138 y en milisegundos en 1973, y no hay capitulos
 * en ninguno de los dos sitios.
 */

const LIMITE = 1e11

export function aMilisegundos(marca: string | number | null | undefined): number {
  const numero = Number(marca)
  if (!Number.isFinite(numero) || numero <= 0) return 0
  return numero < LIMITE ? numero * 1000 : numero
}

/** Dia corto: "20 ago 2026". Vacio si la fuente no dio fecha. */
export function comoDia(marca: string | number | null | undefined): string {
  const ms = aMilisegundos(marca)
  if (!ms) return ''
  return new Date(ms).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

/** Hora del reloj: "01:52". */
export function comoHora(marca: string | number | null | undefined): string {
  const ms = aMilisegundos(marca)
  if (!ms) return ''
  return new Date(ms).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })
}

/**
 * Encabezado de un grupo de novedades. "Hoy" y "Ayer" se leen de un vistazo;
 * dentro de la semana el dia de la semana ubica mejor que la fecha; y de ahi
 * en adelante ya hace falta el numero.
 */
export function comoDiaRelativo(ms: number): string {
  const dia = new Date(ms)
  dia.setHours(0, 0, 0, 0)
  const hoy = new Date()
  hoy.setHours(0, 0, 0, 0)

  const dias = Math.round((hoy.getTime() - dia.getTime()) / 86400000)
  if (dias <= 0) return 'Hoy'
  if (dias === 1) return 'Ayer'
  if (dias < 7) {
    const nombre = new Date(ms).toLocaleDateString('es-ES', { weekday: 'long' })
    return nombre.charAt(0).toUpperCase() + nombre.slice(1)
  }
  return new Date(ms).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: dia.getFullYear() === hoy.getFullYear() ? undefined : 'numeric',
  })
}
